export const GridIcon = (props) => {
  return (
    <svg
    width={props?.width ?? '20'}
    height={props.height ?? '20'}
      viewBox="0 0 20 20"
      {...props}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1082_38739)">
        <path
          d="M0.118164 4.86657C0.118164 3.79061 0.118164 2.72263 0.118164 1.64667C0.118164 0.969217 0.500566 0.586655 1.16977 0.586655C3.33672 0.586655 5.50366 0.586655 7.67061 0.586655C8.31591 0.586655 8.70628 0.977187 8.70628 1.63073C8.70628 3.79858 8.70628 5.96643 8.70628 8.13428C8.70628 8.78783 8.31591 9.17836 7.67061 9.17836C5.50366 9.17836 3.33672 9.17836 1.16977 9.17836C0.500566 9.17836 0.118164 8.78783 0.118164 8.11834C0.118164 7.03442 0.118164 5.95049 0.118164 4.86657Z"
          fill={props?.color ?? '#5B5B5B'}
          // fill={props?.view === 'grid' ? '#3D5A80' : '#5B5B5B'}
        />
        <path
          d="M14.9121 9.1782C13.8366 9.1782 12.7611 9.1782 11.6935 9.1782C11.0084 9.1782 10.626 8.79564 10.626 8.11022C10.626 5.96628 10.626 3.81436 10.626 1.67042C10.626 0.977029 11.0004 0.594467 11.6856 0.594467C13.8445 0.594467 16.0035 0.594467 18.1545 0.594467C18.8237 0.594467 19.2061 0.984999 19.2061 1.64651C19.2061 3.80639 19.2061 5.9583 19.2061 8.11819C19.2061 8.80361 18.8237 9.1782 18.1306 9.1782C17.0551 9.1782 15.9876 9.1782 14.9121 9.1782Z"
          fill={props?.color ?? '#5B5B5B'}
          // fill={props?.view === 'grid' ? '#3D5A80' : '#5B5B5B'}
        />
        <path
          d="M0.118164 15.387C0.118164 14.3111 0.118164 13.2431 0.118164 12.1671C0.118164 11.4737 0.4926 11.0912 1.1857 11.0912C3.34468 11.0912 5.50366 11.0912 7.65468 11.0912C8.32388 11.0912 8.70628 11.4817 8.70628 12.1512C8.70628 14.3111 8.70628 16.463 8.70628 18.6229C8.70628 19.2923 8.32388 19.6829 7.65468 19.6829C5.48773 19.6829 3.32078 19.6829 1.15384 19.6829C0.508533 19.6829 0.118164 19.2844 0.118164 18.6388C0.118164 17.5549 0.118164 16.4709 0.118164 15.387Z"
          fill={props?.color ?? '#5B5B5B'}
          // fill={props?.view === 'grid' ? '#3D5A80' : '#5B5B5B'}
        />
        <path
          d="M14.9123 11.0912C15.9879 11.0912 17.0634 11.0912 18.1309 11.0912C18.824 11.0912 19.2064 11.4737 19.2064 12.1512C19.2064 14.3111 19.2064 16.463 19.2064 18.6229C19.2064 19.2923 18.824 19.6749 18.1468 19.6749C15.9879 19.6749 13.8289 19.6749 11.6779 19.6749C11.0087 19.6749 10.6183 19.2923 10.6183 18.6229C10.6183 16.455 10.6183 14.2872 10.6183 12.1193C10.6183 11.4658 11.0087 11.0832 11.6619 11.0832C12.7454 11.0912 13.8289 11.0912 14.9123 11.0912Z"
          fill={props?.color ?? '#5B5B5B'}
          // fill={props?.view === 'grid' ? '#3D5A80' : '#5B5B5B'}
        />
      </g>
    </svg>
  );
};
